import React from 'react';
import { Badge } from '../ui';

/**
 * Spec 014b US-1: marks a host entry this site's brand took from its hosts.
 * Only a brand admin (or the platform owner) sees such entries.
 */
export function AdminOnlyBadge({ testId }: { testId?: string }) {
  return (
    <Badge
      tone="warning"
      size="sm"
      title="Hidden from hosts on this site"
      data-testid={testId ?? 'admin-only-badge'}
    >
      Admin only
    </Badge>
  );
}

export default AdminOnlyBadge;
